<template>
  <v-dialog v-model="display" @click:outside="resolver(null)" :width="width">
    <v-card>
      <v-card-title>
        <slot name="title">
          {{ $t('please_confirm') }}
        </slot>
      </v-card-title>
      <v-card-text>
        <slot name="default">
        </slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="resolver(false)">
          {{ rejectText || this.$t('cancel') }}
        </v-btn>
        <v-btn color="primary" @click="resolver(true)">
          {{ confirmText || this.$t('ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
/**
 * Generic modal ok/cancel confirm box. Calling confirm() yields a promise that will be resolved when the buttons
 * are clicked.
 */
export default {
  name: 'DialogConfirm',
  props: {
    confirmText: {
      type: String
      // Can't specify default via $t here, so doing it in the template.
    },
    rejectText: {
      type: String
    },
    width: {
      type: String,
      default: '50%'
    }
  },
  data () {
    return {
      display: false,
      resolver: null
    }
  },
  methods: {
    /**
     * Return a promise that will be resolved when a choice is made on the confirmation modal. (Really, whenever the
     * resolver is called, and with whatever value provided to the resolver)
     * @returns {Promise<unknown>}
     */
    async confirm () {
      this.display = true
      return new Promise((resolve, reject) => {
        this.resolver = resolve
      }).finally(() => {
        this.display = false
      })
    }
  }
}
</script>

<style scoped>

</style>
